import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const TwitterIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M15.24 5.201c.64-.39 1.12-1.002 1.35-1.723-.603.363-1.262.619-1.95.757-.865-.933-2.204-1.237-3.38-.766-1.175.47-1.948 1.62-1.95 2.9.001.239.028.476.08.71-2.474-.127-4.778-1.311-6.34-3.26-.277.474-.422 1.016-.42 1.568-.088 1.004.339 1.985 1.13 2.596-.554-.08-1.1-.211-1.63-.39v.04c.106 1.528 1.222 2.787 2.71 3.058-.223.072-.456.11-.69.109-.175 0-.35-.018-.52-.056.413 1.274 1.577 2.144 2.9 2.166-1.085.869-2.428 1.34-3.81 1.335-.24 0-.481-.014-.72-.044 2.695 1.75 6.117 1.87 8.925.313 2.808-1.556 4.555-4.542 4.555-7.785 0-.135-.01-.27-.01-.406.6-.44 1.119-.987 1.53-1.612-.559.252-1.152.417-1.76.49z"
  }
));

export { TwitterIcon as default };
//# sourceMappingURL=TwitterIcon.js.map
